import { render } from "./BenefitQuickCreateModal.vue?vue&type=template&id=b093c982&scoped=true"
import script from "./BenefitQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./BenefitQuickCreateModal.vue?vue&type=script&lang=js"

import "./BenefitQuickCreateModal.vue?vue&type=style&index=0&id=b093c982&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b093c982"]])

export default __exports__